export default {
  LOAD_STUDY_PROGRAM_THEORETICAL_PART_LIST_START: 'LoadStudyProgramTheoreticalPartListStart',
  LOAD_STUDY_PROGRAM_THEORETICAL_PART_LIST_END: 'LoadStudyProgramTheoreticalPartListEnd',
  TOGGLE_STUDY_PROGRAM_THEORETICAL_PART_LIST_CONFIRM_DIALOG: 'ToggleStudyProgramTheoreticalPartListConfirmDialog'
};